export const cardInventoryControl = {
	cardInfo: {
		stockist: "Estoquista:",
		editedIn: "Editado em:",
		status: "Status:",
	},
};
